export const DATABASECONNECTION_DELETE_RESET = 'DATABASECONNECTION_DELETE_RESET'
export const DATABASECONNECTION_DELETE_SET_ERROR = 'DATABASECONNECTION_DELETE_SET_ERROR'
export const DATABASECONNECTION_DELETE_SET_DELETED = 'DATABASECONNECTION_DELETE_SET_DELETED'
export const DATABASECONNECTION_DELETE_TOGGLE_LOADING = 'DATABASECONNECTION_DELETE_TOGGLE_LOADING'
